module.exports = __webpack_public_path__ + "img/trademark_protection_card.830be683.svg";